import React, { createContext, useState, useCallback } from "react";

export const CurrencyContext = createContext(null);

const CURRENCY_STORAGE_KEY = "app_currency";
const SUPPORTED_CURRENCIES = ["MYR", "SGD"];

const getInitialCurrency = () => {
  const stored = localStorage.getItem(CURRENCY_STORAGE_KEY);
  return SUPPORTED_CURRENCIES.includes(stored) ? stored : "SGD";
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(getInitialCurrency);

  const setCurrency = useCallback((nextCurrency) => {
    if (!SUPPORTED_CURRENCIES.includes(nextCurrency)) return;
    localStorage.setItem(CURRENCY_STORAGE_KEY, nextCurrency);
    setCurrencyState(nextCurrency);
  }, []);

  const value = {
    currency,
    setCurrency,
    supportedCurrencies: SUPPORTED_CURRENCIES,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};
